/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(status) {
        return axiosJwt
            .get(
                `${api}/credenciados/gerentes/solicitacoesreaberturas?status=${status}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovar(solicitacaoReaberturaReprovada) {
        return axiosJwt
            .post(
                `${api}/credenciados/gerentes/solicitacoesreaberturas/${solicitacaoReaberturaReprovada.solicitacaoReaberturaId}/reprovar`,
                solicitacaoReaberturaReprovada
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovar(solicitacaoReaberturaId) {
        return axiosJwt
            .patch(
                `${api}/credenciados/gerentes/solicitacoesreaberturas/${solicitacaoReaberturaId}/aprovar`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
